export interface  MinimumContractValue {
    owner_type: string;
    owner_id: string;

    label: string;
    type: MinimumContractValueType;

    weekly_amount: number;
    weekly_hours: number;
    daily_amount: number;
    daily_hours: number;

    rules: any;
}

export interface  MinimumContractValueSet {
    data: MinimumContractValue;
}

export enum MinimumContractValueType {
    daily = 'daily',
    weekly = 'weekly',
}
